var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgG(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.5 50.37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.35 50.37-8.35-8.26v-33.88l8.28-8.23h21.82l8.4 8.3v11.43h-14.49v-6.62l-1.27-1.24h-7.12l-1.27 1.26v24.15l1.27 1.22h7.12l1.27-1.2v-4.32h-3.59v-10.9h18.08v20.03l-8.4 8.26z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8.99 48.85-7.47-7.39v-32.58l7.4-7.36h20.54l7.52 7.43v9.27h-11.45v-5.76l-2.14-2.11h-8.4l-2.16 2.11v25.49l2.16 2.07h8.4l2.14-2.07v-6.49h-3.59v-7.86h15.04v17.86l-7.52 7.39z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.09 40.81v-31.28l6.48-6.48h19.24l6.56 6.55v7.06h-8.27v-4.85l-3.06-3.06h-9.69l-3.07 3.06v26.79l3.07 3.06h9.69l3.06-3.06v-8.69h-3.63v-4.78h11.9v15.68l-6.56 6.55h-19.17z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/g.8c423d881d4ebfb006126d9f6e2ca9a3.svg";
export { ForwardRef as ReactComponent };